<div class="agpr-foldersPicker">
    <div class="agpr-foldersPicker-header">
        <span class="agpr-foldersPicker-headerTitle">
            {{ 'Mention.details.folders' | localize }}
        </span>
    </div>
    <div
        class="agpr-foldersPicker-autocomplete"
        [ngClass]="{'agpr-foldersPicker-autocomplete--withChips': folderChips?.length}"
    >
        <agpr-autocomplete
            #autocomplete
            labelField="name"
            placeholder="Mention.details.addToFolder"
            [dropdown]="true"
            [(ngModel)]="selectedFolder"
            (itemSelected)="folderSelected($event)"
            [suggestions]="folderList$"
            [valueForSuggestions]="folders"
            selectedItemsHideKey="id"
            [ariaLabel]="'Mention.details.folders' | localize"
        ></agpr-autocomplete>
    </div>
    <div
        *ngIf="folderChips?.length"
        class="agpr-foldersPicker-chips"
    >
        <agpr-chip-container
            [chips]="folderChips"
            (removeChip)="folderRemoved($event)"
        ></agpr-chip-container>
    </div>
</div>
